import request from '../../../request/actions';

export const GET_USER_STATS_BY_CATEGORY_START = `GET_USER_STATS_BY_CATEGORY_START`;
export const GET_USER_STATS_BY_CATEGORY_SUCCESS = `GET_USER_STATS_BY_CATEGORY_SUCCESS`;
export const GET_USER_STATS_BY_CATEGORY_FAILURE = `GET_USER_STATS_BY_CATEGORY_FAILURE`;

export const getUserStatsByCategoryStart = () => ({
  type: GET_USER_STATS_BY_CATEGORY_START,
});

export const getUserStatsByCategorySuccess = (statsByQuiz, category) => ({
  type: GET_USER_STATS_BY_CATEGORY_SUCCESS,
  statsByQuiz,
  category,
});

export const getUserStatsByCategoryFailure = (error) => ({
  type: GET_USER_STATS_BY_CATEGORY_FAILURE,
  error,
});

export const getUserStatsByCategory = (userId, categoryId) => {
  return async (dispatch) => {
    try {
      dispatch(getUserStatsByCategoryStart());
      const response = await dispatch(request(`/users/${userId}/stats/?category_id=${categoryId}`, `GET`));
      await dispatch(getUserStatsByCategorySuccess(response.data, response.data.category));
    } catch (error) {
      dispatch(getUserStatsByCategoryFailure(error));
    }
  };
};

export default getUserStatsByCategory;
